<template>
  <div class="flex items-start">
    <div class="flex items-center h-5">
      <input
        ref="input"
        v-model="$attrs.modelValue"
        v-bind="$attrs"
        :class="'form-' + type"
        :id="id"
        :type="type"
      >
    </div>
    <div class="ml-3 text-sm leading-5">
      <slot name="default" />
      <label v-if="label" class="text-gray-700" :for="id">
        {{ label }}
      </label>
      <p v-if="text" class="text-gray-500">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
import uid from '@/helpers/uid';
import { ref } from 'vue';

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: uid
    },
    label: String,
    text: String,
    type: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const input = ref();

    function focus() {
      input.value.focus();
    }

    return {
      input,
      focus,
    }
  }
}
</script>
